import React,{useEffect,useRef} from "react";
import classes from "./CurveNameInfo.module.css";


import gsap from "gsap";

const CurveNameInfo = (props) => {
    const container = useRef(null)
    useEffect(() => {
        gsap.from(container.current, {
          delay: 0.5,
          duration: 0.5,
          opacity: 0,
          xPercent: 100,
          stagger: 0.1,
        });

      }, []);
    
  return (
    <div className={classes.container} ref={container}>
      <h1>Name your chair at LWAH’s Auditorium!</h1>
      <div className={classes.info}>
        Whether it is to honor your family, children or someone who plays a
        significant role in your life, or to leave your own print at LWAH’s
        premises, you can now name a chair in our Auditorium, and contribute to
        the rehabilitation of persons with special needs, touching their lives
        forever.<br/> With a donation of $3000 or $1500 (according to chair
        location), a nameplate with your name or a name of your choice will be
        permanently affixed to the back of an available chair in the Auditorium.
        Shortly after application, you will receive photos and a certificate of
        donation.
      </div>
    </div>
  );
};
export default CurveNameInfo;
